import { getBusinessDateString, isEmptyArray } from '@vista/omnichannel-components-domain';
import { DateShowtimePickerSelectedBusinessDate } from '../types/selected-business-date';
export const getSelectedBusinessDate = (selectedBusinessDate, screeningDates) => {
    switch (selectedBusinessDate) {
        case DateShowtimePickerSelectedBusinessDate.Today: {
            return getCurrentBusinessDate();
        }
        case DateShowtimePickerSelectedBusinessDate.NextAvailable: {
            return getNextAvailableBusinessDate(screeningDates);
        }
        default: {
            return selectedBusinessDate;
        }
    }
};
const getCurrentBusinessDate = () => getBusinessDateString(new Date());
const getNextAvailableBusinessDate = (screeningDates) => {
    if (!screeningDates || isEmptyArray(screeningDates))
        return getCurrentBusinessDate();
    return screeningDates.sort(compareScreeningDates)[0].businessDate;
};
const compareScreeningDates = (a, b) => {
    return a.businessDate < b.businessDate ? -1 : a.businessDate > b.businessDate ? 1 : 0;
};
